// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import {
  FETCH_RELEASE_NOTES_REQUEST,
  DELETE_RELEASE_NOTES_REQUEST,
  FETCH_RELEASE_NOTE_REQUEST,
  UPDATE_RELEASE_NOTES_REQUEST,
  OPEN_EDIT_RELEASE_NOTE_PAGE,
} from './actionTypes';
import {
  fetchReleaseNotesSuccess,
  fetchReleaseNotesFailure,
  deleteReleaseNoteSuccess,
  deleteReleaseNoteFailure,
  fetchReleaseNoteSuccess,
  fetchReleaseNoteFailure,
  updateReleaseNoteSuccess,
  updateReleaseNoteFailure,
  openEditReleaseNotePageSuccess,
} from './actions';
import { deleteReleaseNote, getAllReleaseNotes, getReleaseNote, updateReleaseNote } from '../../helpers/backend_helper';
import { reduxSerializedError } from '../../utils/utils';

function* fetchReleaseNotesSaga() {
  try {
    const response = yield call(getAllReleaseNotes);
    response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    yield put(fetchReleaseNotesSuccess(response));
  } catch (error) {
    yield put(fetchReleaseNotesFailure(reduxSerializedError(error)));
  }
}

function* fetchReleaseNoteSaga({ payload }) {
  try {
    const response = yield call(getReleaseNote, payload);
    yield put(fetchReleaseNoteSuccess(response));
  } catch (error) {
    yield put(fetchReleaseNoteFailure(reduxSerializedError(error)));
  }
}

function* deleteReleaseNotesSaga({ payload }) {
  try {
    yield call(deleteReleaseNote, payload);
    yield put(deleteReleaseNoteSuccess(payload));
    yield call(fetchReleaseNotesSaga); // Refresh the releaseNote list
  } catch (error) {
    yield put(deleteReleaseNoteFailure(reduxSerializedError(error)));
  }
}

function* updateReleaseNoteSaga({ payload }) {
  const { releaseNote, navigate } = payload;
  try {
    yield call(updateReleaseNote, releaseNote);
    navigate(`/releaseNotes`);
    yield put(updateReleaseNoteSuccess());
    yield call(fetchReleaseNotesSaga); // Refresh the releaseNote list
  } catch (error) {
    yield put(updateReleaseNoteFailure(reduxSerializedError(error)));
  }
}

function* openEditReleaseNotePageSaga({ payload }) {
  const { id, navigate } = payload;
  try {
    navigate(`/releaseNotes/new/${id}`);
    yield put(openEditReleaseNotePageSuccess());
  } catch (error) {
    console.error('Navigation error:', error);
  }
}

export default function* rootSaga() {
  yield takeEvery(FETCH_RELEASE_NOTES_REQUEST, fetchReleaseNotesSaga);
  yield takeEvery(FETCH_RELEASE_NOTE_REQUEST, fetchReleaseNoteSaga);
  yield takeEvery(UPDATE_RELEASE_NOTES_REQUEST, updateReleaseNoteSaga);
  yield takeEvery(DELETE_RELEASE_NOTES_REQUEST, deleteReleaseNotesSaga);
  yield takeEvery(OPEN_EDIT_RELEASE_NOTE_PAGE, openEditReleaseNotePageSaga);
}
